// extracted by mini-css-extract-plugin
export default {"userIdContainer":"VT6NFZVNYLQl20aS_cR6","successDescription":"Z2JR4368MnxIO9CvIL4v"};